import { colours } from './trustLibrary';

const professionalGarments = new Set(['no_uniform', 'smart_clothes', 'shirt_trousers', 'dress']);
export const isProfessionalGarment = id => professionalGarments.has(id);
export const legacyAssignmentValue = id => `legacy:${id}`;
export const customAssignmentValue = id => `custom:${id}`;

export function uniformAssignmentOptions(definitions = {}) {
  const legacy = colours.map(colour => ({ value: legacyAssignmentValue(colour.id), label: colour.name, body: colour.body, trim: colour.trim, kind: 'legacy' }));
  const shared = Object.values(definitions)
    .map(item => ({ value: customAssignmentValue(item.id), label: item.name, body: item.bodyHex, trim: item.trimHex, templateId: item.templateId, kind: 'custom' }))
    .sort((a,b)=>a.label.localeCompare(b.label,'en',{sensitivity:'base'}) || a.value.localeCompare(b.value));
  return [...legacy, ...shared];
}

export function selectedUniformAssignment(uniform = {}) {
  return uniform.uniformDefinitionId ? customAssignmentValue(uniform.uniformDefinitionId) : legacyAssignmentValue(uniform.colourId || 'no_uniform');
}

export function applyUniformAssignment(uniform = {}, value) {
  if (value.startsWith('custom:')) return { ...uniform, uniformDefinitionId: value.slice(7) };
  if (value.startsWith('legacy:')) {
    const colourId = value.slice(7);
    const next = { ...uniform, colourId, uniformDefinitionId: null };
    if (colourId === 'no_uniform') next.garmentId = 'no_uniform';
    else if (isProfessionalGarment(next.garmentId)) next.garmentId = 'scrubs';
    return next;
  }
  throw new Error('Choose an available uniform.');
}

export function uniformAssignmentPreview(uniform = {}, definitions = {}) {
  const definition = definitions[uniform.uniformDefinitionId];
  if (definition) return { name: definition.name, body: definition.bodyHex, trim: definition.trimHex, templateId: definition.templateId || 'scrub-vneck-v1', pocketPipingHex: definition.pocketPipingHex || null, professional: false, badge: definition.badge };
  const colour = colours.find(item => item.id === uniform.colourId);
  const fixedLegacy = uniform.colourId === 'paramedic_green' ? { name: 'Paramedic uniform', body: '#006747', trim: '#1E3A5F' } : null;
  const professional = isProfessionalGarment(uniform.garmentId) || uniform.colourId === 'no_uniform';
  const templateId = uniform.garmentId === 'healthcare_tunic' ? 'healthcare-tunic-v1' : 'scrub-vneck-v1';
  return { name: colour?.name || fixedLegacy?.name || 'No standard uniform', body: colour?.body || fixedLegacy?.body || '#6B7280', trim: colour?.trim || fixedLegacy?.trim || '#374151', templateId, pocketPipingHex: null, professional, badge: { assetId: 'nhs-standard', visible: true } };
}
